import React from 'react';
import { CTAButton } from './CTAButton';
import { pricing } from '../data/pricing';
import { trackPixelEvent } from '../utils/metaPixel';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-white scroll-mt-8" data-id="element-104" data-mp="1eiifnka4q53h">
      <div className="max-w-3xl mx-auto text-center" data-id="element-105" data-mp="1eg5p4iqb2met">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-14" data-id="element-106" data-mp="1ja0fu64bw1ne">
          Oferta Especial de Lanzamiento
        </h2>

        <div className="bg-white rounded-[2rem] border-2 border-brand-green p-8 md:p-12 shadow-xl relative max-w-xl mx-auto" data-id="element-107" data-mp="1naandn7rr04d">
          <p className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-green text-white px-6 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase whitespace-nowrap" data-id="element-108" data-mp="1x8qbrifevva6">
            Contenido del kit
          </p>

          <dl className="space-y-4 mb-8 text-left" data-id="element-109" data-mp="2vqr3aw6caw1">
            {pricing.lineItems.map(item => <div key={item.label} className="flex justify-between items-center gap-6 border-b border-brand-creamDark pb-4" data-id="element-110" data-mp="7ul7y7akzpdi">
                <dt className="text-brand-text font-medium" data-id="element-111" data-mp="1hpg389cvne4j">{item.label}</dt>
                <dd className="text-brand-terracotta font-medium" data-id="element-112" data-mp="1cqv3eb1jewgm">
                  {item.price}
                </dd>
              </div>)}
            <div className="flex justify-between items-center gap-6 pt-2" data-id="element-113" data-mp="17t39xcl8v2ab">
              <dt className="font-bold text-brand-text" data-id="element-114" data-mp="25fskwbxxcp8b">VALOR TOTAL:</dt>
              <dd className="font-bold text-brand-terracotta" data-id="element-115" data-mp="20gfxnq355g57">
                {pricing.fullValue}
              </dd>
            </div>
          </dl>

          <div className="text-center mb-8" data-id="element-116" data-mp="1vg1sqgwu6mbe">
            <p className="text-5xl md:text-6xl font-black text-brand-green tracking-tight mb-1" data-id="element-117" data-mp="1rfrjmvdqzfsb">
              {pricing.price}
            </p>
            <p className="text-sm font-bold uppercase tracking-widest text-brand-green/70 mb-3" data-id="element-118" data-mp="k393bcriq9yi">
              {pricing.currencyNote}
            </p>
            <p className="text-brand-gray line-through font-medium text-lg mb-2" data-id="element-119" data-mp="hhru10tt93oq">
              {pricing.fullValue}
            </p>
            <p className="text-sm text-brand-gray font-medium" data-id="element-120" data-mp="mh4fbh51a2p7">
              Con tarjeta o Mercado Pago
            </p>
          </div>

          <CTAButton href="https://yoga-listo.impultienda.ar/checkout" onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: 'Kit Yoga Lista',
          currency: 'ARS',
          value: 19990
        })} className="w-full mb-6 text-base md:text-lg py-5" data-id="element-121" data-mp="7jc1ctf4xmd4">
            Quiero el Kit Yoga Lista
          </CTAButton>

          <p className="text-xs text-brand-gray font-medium" data-id="element-122" data-mp="3pxbjdord21yi">
            Descarga inmediata &middot; Pago único &middot; Acceso de por vida
            &middot; 7 días de garantía
          </p>
          <p className="mt-2 text-xs text-brand-gray" data-id="element-123" data-mp="3fzdtyxxrlz4b">
            Precio final en pesos. No genera suscripción ni cobros futuros.
          </p>
        </div>
      </div>
    </section>;
}